import { isStreamHealthEvent, type StreamHealthEvent } from '@playcastdotio/PeerCore';

/** Transition-only events share the existing health sink; no extra timer or log stream. */
export class RecoveryTelemetry {
  private readonly last = new Map<string, string>();
  constructor(private readonly emit: (event: StreamHealthEvent) => void, private readonly nowMs: () => number) {}
  public record(key: string, kind: StreamHealthEvent['kind'], detail: NonNullable<StreamHealthEvent['detail']>): boolean {
    const event: StreamHealthEvent = { kind, stream: 'video', atMs: this.nowMs(), detail };
    // Do not manufacture missing required evidence to make an invalid record acceptable.
    if (!isStreamHealthEvent(event)) return false;
    // The running dwell is measured on each sample, but only decision transitions need
    // another event. Its actual value is retained in every emitted transition.
    const transition = kind === 'quality-tier-decision' ? { ...detail, qualifyingMs: undefined } : detail;
    const fingerprint = JSON.stringify([kind, transition]);
    if (this.last.get(key) === fingerprint) return false;
    this.last.set(key, fingerprint);
    this.emit(event);
    return true;
  }
}
